import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Link } from 'react-router-dom';


// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import TrainingCertificationLogbooksModal from './TrainingCertificationLogbooksModal';
import TrainingCertificationLogbooksDuplicateModal from './TrainingCertificationLogbooksDuplicateModal';
import TrainingLogbooksTabAddFile from './TrainingLogbooksTabAddFile';
import getLocale from '../../../i18n/getLocale';
//import TrainingCertificationsModLogbookslView from './TrainingCertificationsModLogbookslView';

class TrainingLogbooksTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      training_id: this.props.training_id,
      training_certification_id: null,
      duplicate_id: null,
      date: null,
      start: null,
      finish: null,
      training_certifications_select: [],
      staff_list: [],
      training_certification_logbooks: [],
      training_certification_logbook: {},
      updated: 0,
      modal_props: false,
      modal_duplicate_props: false,
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.editModal = this.editModal.bind(this);
    this.closeModalParent = this.closeModalParent.bind(this);
    this.updateDataModal = this.updateDataModal.bind(this);
    this.generatePayments = this.generatePayments.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }


  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_data.name !== 'undefined' && Array.isArray(newProps.training_certification_logbooks) && Array.isArray(newProps.training_certifications_select) && Array.isArray(newProps.staff_list)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        name: newProps.training_data.name,
        training_id: newProps.training_data.id,
        training_certification_logbooks: newProps.training_certification_logbooks,
        training_certifications_select: newProps.training_certifications_select,
        staff_list: newProps.staff_list,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      training_id: this.state.training_id,
      training_certification_id: this.state.training_certification_id,
      date: this.state.date,
      start: this.state.start,
      finish: this.state.finish,
      examiner_id: this.state.examiner_id,
      instructor_id: this.state.instructor_id,
      pf_id: this.state.pf_id,
      pm_id: this.state.pm_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado/logbook', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  updateDataModal (responseJson) {
    var header = this.setState({updated: 1});
    var self = this;
    Promise.resolve(header).then(function(value) {
      self.editModal(responseJson);
    });
  }

  editModal (event) {
    if (this.state.updated == 0) {
      var training_certification_logbook_id = event.id;
      this.props.handleAlert('', '', 'open');
    } else {
      var training_certification_logbook_id = event.data.training_certification_logbook_id;
    }
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/certificado/logbook/tripulantes/' + training_certification_logbook_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          if (self.state.updated == 1) {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.setState({modal_props: true, training_certification_logbook: event, training_certification_logbook_staffs: responseJson.data, training_certification_logbook_id: training_certification_logbook_id});
            self.props.handleAlert('', '', 'closed');
          }
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      });
    });
  }

  finalize (id) {
    var training_certification_logbook_id = id;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabLogbook.finalizarSessao);
    if (confirm) {
      var datasave = {
      };
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/logbook/finalizar/' + training_certification_logbook_id, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  reopen (id) {
    var training_certification_logbook_id = id;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabLogbook.reabrirSessao);
    if (confirm) {
      var datasave = {
      };
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/logbook/reabrir/' + training_certification_logbook_id, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  delete (id) {
    var training_certification_logbook_id = id;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabLogbook.deletarSessao);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/logbook/' + training_certification_logbook_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  generatePayments (id) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/gerar/pagamentos/logbook/' + self.state.training_id, { method: 'PUT', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.updateData(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  closeModalParent() {
    var responseJson = {
      status: 'success',
      message: this.locale.Treinamentos.EditarTreinamento.tabLogbook.dadosAtualizadosComSucesso,
    };
    this.props.handleAlert('', '', 'open');
    this.setState({modal_props: false, modal_duplicate_props: false, updated: 0}, this.props.updateData(responseJson));
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title pull-left">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tituloAdicionarSessao}</h3>
  <button className="btn btn-success pull-right" onClick={() => self.generatePayments()}>
    <i className="fa fa-fw fa-check"></i> {this.locale.Treinamentos.EditarTreinamento.tabLogbook.botaoConfirmarHoras}
  </button>
  <div className="clearfix"></div>
  <hr/>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.Certificado}:</label>
          <Select
            className="form-field-name"
            name="training_certification_id"
            value={this.state.training_certification_id}
            searchable={true}
            placeholder={this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.placeholder.SelecionarCertificado}
            onChange={this.handleSelectChange.bind(this, 'training_certification_id')}
            options={this.state.training_certifications_select}
            required
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.Data}:</label>
          <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.placeholder.Data} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.Inicio}:</label>
          <InputMask value={this.state.start}  maskChar={null} name="start" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'start')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.placeholder.HorarioDeInicio} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.Fim}:</label>
          <InputMask value={this.state.finish}  maskChar={null} name="finish" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'finish')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.placeholder.HorarioDeFim} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-3">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.Examinador}:</label>
          <Select
            className="form-field-name"
            name="examiner_id"
            value={this.state.examiner_id}
            searchable={true}
            placeholder={''}
            onChange={this.handleSelectChange.bind(this, 'examiner_id')}
            options={this.state.staff_list}
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.Instrutor}:</label>
          <Select
            className="form-field-name"
            name="instructor_id"
            value={this.state.instructor_id}
            searchable={true}
            placeholder={''}
            onChange={this.handleSelectChange.bind(this, 'instructor_id')}
            options={this.state.staff_list}
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.PilotFlying}:</label>
          <Select
            className="form-field-name"
            name="pf_id"
            value={this.state.pf_id}
            searchable={true}
            placeholder={''}
            onChange={this.handleSelectChange.bind(this, 'pf_id')}
            options={this.state.staff_list}
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.PilotMonitoring}:</label>
          <Select
            className="form-field-name"
            name="pm_id"
            value={this.state.pm_id}
            searchable={true}
            placeholder={''}
            onChange={this.handleSelectChange.bind(this, 'pm_id')}
            options={this.state.staff_list}
          />
        </div>
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarSessao.botaoAdicionarSessao}</button>
  </form>
  <hr/>
  <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tituloListaDeSessoes}</h3>
  <hr/>
  <table className="table table-bordered table-hover">
    <thead>
      <tr>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.Certificado}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.Inicio}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.Fim}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.HorasTotais}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.Tripulacao}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.Arquivo}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.Status}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.Acoes}</th>
      </tr>
    </thead>
    <tbody id="training-certification-staffs">
      {Object.keys(self.state.training_certification_logbooks).map(function(k) {
        return (
          <tr>
            <td className="text-center">{self.state.training_certification_logbooks[k].training_certification.certification.name}</td>
            <td className="text-center">{self.state.training_certification_logbooks[k].start_str}</td>
            <td className="text-center">{self.state.training_certification_logbooks[k].finish_str}</td>
            <td className="text-center">{self.state.training_certification_logbooks[k].hours_str}</td>
            <td className="text-center">{self.state.training_certification_logbooks[k].staffs}</td>
            <td className="text-center">
              <TrainingLogbooksTabAddFile handleAlert={self.props.handleAlert} updateData={self.props.updateData} id={self.state.training_certification_logbooks[k].id} file={self.state.training_certification_logbooks[k].file} file_archived={self.state.training_certification_logbooks[k].file_archived} />
            </td>
            <td className="text-center">
              {self.state.training_certification_logbooks[k].status === 0 && <span className="label label-danger">{self.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.Aberto}</span>}
              {self.state.training_certification_logbooks[k].status === 1 && <span className="label label-primary">{self.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.Finalizado}</span>}
              {self.state.training_certification_logbooks[k].status === 2 && <span className="label label-success">{self.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaListaDeSessoes.Confirmado}</span>}
            </td>
            <td className="col-md-2 text-center">
              <button className="btn btn-primary btn-sm" onClick={() => self.editModal(self.state.training_certification_logbooks[k])}>
                <i className="fa fa-fw fa-users"></i>
              </button>
              <button className="btn btn-warning btn-sm" onClick={() => {self.setState({modal_duplicate_props: true, duplicate_id: self.state.training_certification_logbooks[k].id})}}>
                <i className="fa fa-fw fa-refresh"></i>
              </button>
              {self.state.training_certification_logbooks[k].status === 0 &&
                <button className="btn btn-danger btn-sm" onClick={() => self.delete(self.state.training_certification_logbooks[k].id)}>
                  <i className="fa fa-fw fa-trash"></i>
                </button>
              }
              {self.state.training_certification_logbooks[k].status === 1 &&
                <button className="btn btn-danger btn-sm" onClick={() => self.reopen(self.state.training_certification_logbooks[k].id)}>
                  <i className="fa fa-fw fa-close"></i>
                </button>
              }
              {self.state.training_certification_logbooks[k].status === 0 &&
                <button className="btn btn-success btn-sm" onClick={() => self.finalize(self.state.training_certification_logbooks[k].id)}>
                  <i className="fa fa-fw fa-check"></i>
                </button>
              }
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
  <TrainingCertificationLogbooksModal handleAlert={this.props.handleAlert} staff_list={this.props.staff_list} training_certification_logbook={this.state.training_certification_logbook} training_certification_logbook_staffs={this.state.training_certification_logbook_staffs} training_certification_logbook_id={this.state.training_certification_logbook_id} modal_props={this.state.modal_props} updateData={this.props.updateData} closeModalParent={this.closeModalParent} updateDataModal={this.updateDataModal} updated={this.state.updated} />
  <TrainingCertificationLogbooksDuplicateModal handleAlert={this.props.handleAlert} modal_duplicate_props={this.state.modal_duplicate_props} duplicate_id={this.state.duplicate_id} updateData={this.props.updateData} closeModalParent={this.closeModalParent} updateDataModal={this.updateDataModal} />
</div>
    );
  }
}

export default TrainingLogbooksTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingLogbooksTab.js